import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';

interface MarketSettingsCentralMappingTablesCellsTdPropertySignature {
  Args: {
    cellData: string;
    row: {
      isParent?: boolean;
    };
  };
}

export default class MarketSettingsCentralMappingTablesCellsTdProperty extends Component<MarketSettingsCentralMappingTablesCellsTdPropertySignature> {
  get dataTestId(): string {
    if (this.args.row.isParent) {
      return 'table-central-mapping-parent-td-property';
    }
    return 'table-central-mapping-td-property';
  }

  <template>
    <div
      class="overflow-hidden text-ellipsis whitespace-nowrap"
      data-test-id={{this.dataTestId}}
    >
      {{#if @cellData}}
        {{@cellData}}

        {{#unless @row.isParent}}
          <EmberTooltip
            @side="bottom"
            @tooltipClass="default-tooltip default-tooltip--large"
          >
            <p class="text-200--regular">{{@cellData}}</p>
          </EmberTooltip>
        {{/unless}}
      {{else}}
        {{t "general.missing"}}
      {{/if}}
    </div>
  </template>
}
